export class XmlToolbox {
  /// <summary>
  /// Ist dieser Node ein als Text bearbeitbarer Node
  /// </summary>
  /// <param name="node"></param>
  /// <returns></returns>
  public static IsTextOrCommentNode(node: Node): boolean {
    switch (node.nodeType) {
      case Node.TEXT_NODE: // text node
      case Node.COMMENT_NODE:
        return true;
      default:
        return false;
    }
    // return ((node.nodeType === System.Xml.XmlText) || (node.nodeType === System.Xml.XmlComment));
  }

  // Gets the info to identify a node for exception or debug purposes
  public static GetNodeDebugContext(node: Node): string {
    if (node === null || node === undefined) {
      return 'NULL';
    }

    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent === ' ' || node.textContent === String.fromCharCode(160)) {
        return `TextContent!Parent=${XmlToolbox.GetNodeDebugContext(node.parentNode)}`;
      } else {
        return `TextContent='${node.textContent}'`;
      }
    }

    const asElem = node as Element;
    if (asElem === undefined) {
      return `localName: ${node.nodeName}, nodeType:${node.nodeType}`;
    } else {
      return asElem.outerHTML;
    }
  }
}
